/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Container, Grid, Heading, Paragraph, Box, Flex } from "theme-ui";
import GalleryItem from "./GalleryItem";
import Action from "../../shared/Action";
import "./gallerySection.css";

export const query = graphql`
  fragment ContentfulGallerySectionFragment on ContentfulGallerySection {
    description {
      description
    }
    heading
    imageOnly
    backgroundColor
    classname
    button {
      actionEvent
      icon
      iconSize
      id
      label
      style
      url
    }
    galleryItems {
      image {
        gatsbyImageData
        file {
          contentType
          url
        }
        description
        title
      }
      title
      description {
        description
      }
      imageWidth
      linkUrl
      button {
        classnameForAnalytics
        actionEvent
        fullWidth
        icon
        iconSize
        id
        style
        label
        url
        form {
            ...FormFragment
        }
        }
    }
  }
`;

const GallerySection = ({ sectionContent }) => {
  const { heading, description, imageOnly, classname, galleryItems, backgroundColor, button} = sectionContent;

  return (
    <Box sx={{backgroundColor:backgroundColor && backgroundColor}}>
    <Container sx={{ py: ["50px", "80px"] }}>
      {heading && (
        <Heading
          as="h3"
          variant="extraBold"
          marginBottom="18px"
          sx={{ textAlign: "center" }}
        >
          {heading}
        </Heading>
      )}
      {description && (
        <Paragraph marginBottom="20px" sx={{ textAlign: "center", fontSize:'24px !important'}}>
          {description.description}
        </Paragraph>
      )}
      <Grid
        columns={[imageOnly ? 1 : 2, imageOnly ? 1 : 2, 2, imageOnly ? 4 : 3]}
        className={classname}
      >
        {galleryItems.slice(0, 8).map((galleryItem) => 
            <GalleryItem
              key={galleryItem.title}
              galleryItem={galleryItem}
              imageOnly={imageOnly}
              imageWidth={galleryItem.imageWidth}
            />
        )}
      </Grid>
      {button && (
        <Flex sx={{alignItems:'center', justifyContent:'center', marginTop:'50px'}}>
          <Action {...button}/>
        </Flex>
      )}
    </Container>
    </Box>
  );
};

export default GallerySection;
